import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LoyaltyProductLogo from 'loyalty/components/LoyaltyProductLogo'
import LoyaltyTierIcon from 'LuxKit/Icons/loyalty/LoyaltyTierIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import { rem } from 'polished'
import type { ReactNode } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const HeroSection = styled.div`
  padding: ${rem(40)} 0;
  background: ${props => props.theme.palette.neutral.control.black100};
  color: ${props => props.theme.palette.neutral.surface.staticWhite};
`

const Columns = styled(Group)`
  ${mediaQueryUp.tablet} {
    align-items: center;
  }
`

const HeroBody = styled.div`
  flex: 1 1 auto;
`

const PanelColumn = styled.div`
  flex: 0 0 auto;
  width: 100%;

  ${mediaQueryUp.tablet} {
    width: ${rem(400)};
  }
`

const TierCoinStack = styled(Group)`
  > * + * {
    margin-left: -${rem(12)};
  }
`

interface Props {
  panel: ReactNode
}

function LoyaltyPurchasePointsHeroSection(props: Props) {
  const { panel } = props
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: '8PY9LRMUH6-9aI0teTdX',
    defaultMessage: 'Top up your Société Points',
    description: 'Hero heading on the Société Buy Points landing page',
  })

  const subhead = intl.formatMessage({
    id: 'iCYEXlAzvYv78xZDRqHv',
    defaultMessage: 'Top up points and start redeeming sooner – on stays, flights and more.',
    description: 'Hero body copy on the Société top-up-points landing page',
  })

  const promoLine = intl.formatMessage({
    id: 'XDgrgp92sHQRMonW-j_A',
    defaultMessage: '20% more points for a limited time only',
    description: 'Hero promo tagline on the Société Buy Points landing page (campaign messaging)',
  })

  return <HeroSection>
    <LayoutContainer variant="medium">
      <Columns direction="vertical" tabletDirection="horizontal" gap={32} tabletGap={40} verticalAlign="center">
        <HeroBody>
          <Group direction="vertical" gap={20} horizontalAlign="start">
            <LoyaltyProductLogo height={32} />
            <VerticalSpacer gap={8}>
              <HeadingTextBlock variant="heading2">{heading}</HeadingTextBlock>
              <HeadingTextBlock variant="heading4" colour="highlight-primary">{promoLine}</HeadingTextBlock>
              <BodyTextBlock variant="large">{subhead}</BodyTextBlock>
              <TierCoinStack direction="horizontal">
                <LoyaltyTierIcon tier="bronze" size={48} />
                <LoyaltyTierIcon tier="silver" size={48} />
                <LoyaltyTierIcon tier="gold" size={48} />
                <LoyaltyTierIcon tier="platinum" size={48} />
              </TierCoinStack>
            </VerticalSpacer>
          </Group>
        </HeroBody>
        <PanelColumn>{panel}</PanelColumn>
      </Columns>
    </LayoutContainer>
  </HeroSection>
}

export default LoyaltyPurchasePointsHeroSection
